import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {FilterDto, InfoListDto, Orders} from "@server-models";
import {ILocalPageOutputDto} from "@shared/interfaces/orga-response.interface";
import {map} from "rxjs/operators";
import {IPaginationParams} from "@shared/interfaces/pagination-params.interface";
import {IRequestOptions} from "@shared/interfaces/request-options.interface";
import {ILocalInfosMyReadDto} from "@team/pages/infos/interfaces/infos-my-read-dto.interface";
import {CoreHttpClientApiBaseService} from "@core/services/http-client-api-base/core-http-client-api-base.service";
import {ILocalRequestPayload} from "@shared/interfaces/local-request-payload.interface";
import {isString} from "lodash";

@Injectable({
  providedIn: 'root',
})
export class TeamInfoService extends CoreHttpClientApiBaseService {

  getInfoList(payload: ILocalRequestPayload): Observable<ILocalPageOutputDto<InfoListDto[]>> {
    const params: Record<string, string> = {
      ...payload.params,
      pageSize: (payload.pagination?.pageSize ?? 10).toString(),
      pageNumber: (payload.pagination?.pageNumber ?? 1).toString(),
      cols: 'Content',
      sortField: 'DateTime',
      sort: Orders.Descending?.toString()
    }

    const endpoint = isString(params['q']) ? '/orga/v2/info/search/filter' : '/orga/v2/info/filter';

    return super.post<ILocalPageOutputDto<InfoListDto[]>>(endpoint, true, payload.filters, { params });
  }

  /**
   * @name postMyReadById
   * @memberof TeamInfoService
   * @description
   * Make a post request to Orga server to mark an info as read by id
   * @param id
   */
  postMyReadById(id: number): Observable<ILocalPageOutputDto<ILocalInfosMyReadDto>> {
    return super.post<ILocalPageOutputDto<ILocalInfosMyReadDto>>(`/orga/v2/me/info/${ id }/read`,
      undefined, undefined, undefined);
  }
}
